import { render, staticRenderFns } from "./TherapyDigitalClinicsBookingPayment.vue?vue&type=template&id=4c942374"
import script from "./TherapyDigitalClinicsBookingPayment.vue?vue&type=script&lang=js"
export * from "./TherapyDigitalClinicsBookingPayment.vue?vue&type=script&lang=js"
import style0 from "./TherapyDigitalClinicsBookingPayment.vue?vue&type=style&index=0&id=4c942374&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports